export const environment = {
  production: true,
  stage: 'prod',
  //old firebase config
  // firebase: {
  //   apiKey: 'AIzaSyBaFtRizEmhxUDOMP8aKO-l88h6_kSARSU',
  //   authDomain: 'salon-market-290016.firebaseapp.com',
  //   databaseURL: 'https://salon-market-290016.firebaseio.com',
  //   projectId: 'salon-market-290016',
  //   storageBucket: 'salon-market-290016.appspot.com',
  //   messagingSenderId: '659787711647',
  //   appId: '1:659787711647:web:b1de4cd208ffd8596c0eaa',
  //   measurementId: 'G-NSLWT02CFQ',
  // },

  //new firebase config
  firebase: {
    apiKey: "AIzaSyCxYFwX7AwnwjQvJ5j5fooLIRZVqtiq-Cs",
    authDomain: "lookzup-platform.firebaseapp.com",
    projectId: "lookzup-platform",
    storageBucket: "lookzup-platform.appspot.com",
    messagingSenderId: "745206404840",
    appId: "1:745206404840:web:a1c513a098bf0954cedb5d",
    measurementId: "G-PHXBBNY951",
  },

  businessImageBaseUrl:
    "https://storage.googleapis.com/salon-market_entity_uploads/",
  businessImageThumbBaseUrl:
    "https://storage.googleapis.com/salon-market_entity_uploads/thumb/",
  profileImageBaseUrl:
    "https://storage.googleapis.com/salon-market_profile_photos/",
  profileImageThumbBaseUrl:
    "https://storage.googleapis.com/salon-market_profile_photos/thumb/",

  //new urls
  apiUserServiceBaseUrl: "https://user-services.lookzup.com/prod",
  apiCommonServiceBaseUrl: "https://common-services.lookzup.com/prod",
  apiTransactionServiceBaseUrl: "https://transaction-services.lookzup.com/prod",
  apiSocialServiceBaseUrl: "https://social-services.lookzup.com/prod",
  apiUploadServiceBaseUrl: "https://upload-services.lookzup.com/prod",
  apiBusinessServiceBaseUrl: "https://business-services.lookzup.com/prod",
  apiAdminServiceBaseUrl: "https://admin-services.lookzup.com/prod",

  //old urls
  //   apiUserServiceBaseUrl:
  //   'https://user-services-dot-salon-market-290016.el.r.appspot.com/prod',
  // apiCommonServiceBaseUrl:
  //   'https://common-services-dot-salon-market-290016.el.r.appspot.com/prod',
  // apiTransactionServiceBaseUrl:
  //   'https://transaction-services-dot-salon-market-290016.el.r.appspot.com/prod',
  // apiSocialServiceBaseUrl:
  //   'https://social-services-dot-salon-market-290016.el.r.appspot.com/prod',
  // apiUploadServiceBaseUrl:
  //   'https://upload-services-dot-salon-market-290016.el.r.appspot.com/prod',

  // razorpayKey: "rzp_live_JsMdD9fm9W7ZKW",
  razorpayKey: "rzp_live_WZCY7VLhffEEur",
  apiFcmServiceBaseUrl:
    "https://us-central1-salon-market-290016.cloudfunctions.net",

  base_lookzup_web_url: "https://lookzup.com",
  base_lookzup_market_website_url: "https://market.lookzup.com",
    base_lookzup_market_mobile_website_url: "https://m.market.lookzup.com",
  base_lookzup_business_url: "https://business.lookzup.com",
  
  base_api_url: "https://service.lookzup.com",
  cookie_hex_key: "e9443a6552cc319763e1a06807fa45e7e05d7f621a06ed27388838c2c9ec5b45",
  paypal_client_id: "AVV7k72-tOWjitqj7lAeAc5LC8uEPXKwOcp7gL9GldoJkdZIZJQ_TRlI1keTRIsc32FX3tXl4WOoYY_h",
  paypal_merchant_id: "8D43PUJXRU788",
  app_type: 'android',
  app_name: 'business',
  current_version: '2.7.0'
};
